import { Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { ReactNode } from 'react'

interface IProps {
    label: string
    onClick?: () => void
    children: ReactNode
}

// Shared round icon button + label used by both the desktop (AppleAuth/FacebookAuth)
// and native (NativeSocialLogin) social-login choices so they stay visually identical.
// Fixed column width keeps the circles evenly spaced regardless of label length.
const SocialButton: React.FC<IProps> = ({ label, onClick, children }) => (
    <Stack gap={1} sx={{ width: '72px', alignItems: 'center' }}>
        <Box
            onClick={onClick}
            sx={{
                border: (theme) => `2px solid ${theme.palette.background.paper}`,
                borderRadius: '50% !important',
                width: '40px',
                height: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                background: '#FFFFFF',
            }}
        >
            {children}
        </Box>
        <Typography variant="body2" noWrap>
            {label}
        </Typography>
    </Stack>
)

SocialButton.displayName = 'SocialButton'

export default SocialButton
